import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Button, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import swal from 'sweetalert2';
import api from 'lib/api';
import sniffer from 'sniffer';
import { addError } from 'actions';
import { createAssessments, updateAssessment, getAssignmentAssessment } from 'actions/assessments';
import { deleteAssignmentUserDocument, getFolderFiles, getTaskDetails } from 'actions/assignments';
import { getBlocksByReference } from 'actions/blocks';
import { getSection } from 'actions/sections';
import { getStudentAssessment, getStudentAssessments } from 'actions/studentassessments';
import SimpleSelect from 'components/Inputs/SimpleSelect';
import AssessmentForm from 'containers/Forms/AssessmentForm';
import WopiFrame from 'containers/WopiFrame/WopiFrame';
import Message from 'containers/SinglePages/Partials/Message';
import jwtDecode from 'jwt-decode';
import { Icon, Tabs, Tab } from '@haldor/ui';
import { Spinner } from 'UI';
import { ASSESSMENT_TYPES } from 'components/BlockAssessments/AssessmentTypes';

var AttachedUserDocuments = /*#__PURE__*/function (_Component) {
  _inherits(AttachedUserDocuments, _Component);

  var _super = _createSuper(AttachedUserDocuments);

  function AttachedUserDocuments(props) {
    var _this;

    _classCallCheck(this, AttachedUserDocuments);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.loadInit(_this.props.taskId);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (window.location.hash == '#assessment') {
        _this.setState({
          sidebarWide: true
        });
      }

      window.addEventListener('hashchange', function () {
        _this.setState({
          sidebarWide: window.location.hash == '#assessment'
        });
      });

      if (_this.props.blocks == null) {
        _this.props.getBlocksByReference(_this.props.assignmentId, 'ASSIGNMENT');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (_this.props.documentRefresh !== nextProps.documentRefresh) {
        _this.loadInit(nextProps.taskId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadInit", function (taskId) {
      _this.loadUserAssignmentAttachedDocument(taskId);

      _this.loadActiveAssignment();

      _this.checkTeamsDesktop();
    });

    _defineProperty(_assertThisInitialized(_this), "loadUserAssignmentAttachedDocument", function (taskId) {
      _this.setState({
        assignmentAttachementLoading: true,
        activeTaskLoading: true,
        selectedDocument: '',
        selectedVideo: '',
        selectedImage: '',
        selectedAudio: ''
      });

      _this.props.assignment.tasks.forEach(function (t) {
        return t.selected = false;
      });

      _this.props.getFolderFiles(_this.props.assignmentId, taskId).then(function () {
        _this.setState({
          assignmentAttachementLoading: false
        });

        var officeFile = _this.props.folderFiles.length > 0 && _this.props.folderFiles.filter(function (f) {
          return f.webUrlViewMode !== '';
        })[0];

        var mp4File = _this.props.folderFiles.length > 0 && _this.props.folderFiles.filter(function (f) {
          return /.mp4$/.test(f.webUrl);
        })[0];

        var m4aFile = _this.props.folderFiles.length > 0 && _this.props.folderFiles.filter(function (f) {
          return /.m4a$/.test(f.webUrl);
        })[0];

        var imageFile = _this.props.folderFiles.length > 0 && _this.props.folderFiles.filter(function (f) {
          return /(.png|.jpg|.gif|.jpeg)$/.test(f.webUrl);
        })[0];

        if (officeFile) {
          _this.setState({
            selectedDocument: officeFile.webUrlViewMode
          });
        } else if (mp4File) {
          _this.setState({
            selectedVideo: mp4File.webUrl
          });
        } else if (imageFile) {
          _this.setState({
            selectedImage: imageFile.webUrl
          });
        } else if (m4aFile) {
          _this.setState({
            selectedAudio: m4aFile.webUrl
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadActiveAssignment", function () {
      _this.setState({
        assignmentLoading: true
      });

      _this.props.getTaskDetails(_this.props.assignmentId).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var tasks;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tasks = _this.props.assignment.tasks.filter(function (t) {
                  return t.id == _this.props.taskId;
                });
                tasks[0].selected = true;
                _context.next = 4;
                return _this.setState({
                  activeTask: tasks,
                  activeTaskLoading: false
                });

              case 4:
                if (!(_this.props.assignment.assessmentType == 'BUDDY' || _this.props.assignment.assessmentType == 'SELF')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return _this.props.getStudentAssessments(_this.props.assignmentId);

              case 7:
                _this.setState({
                  assignmentLoading: false
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));

      _this.props.getAssignmentAssessment(_this.props.assignmentId);
    });

    _defineProperty(_assertThisInitialized(_this), "checkTeamsDesktop", function () {
      _this.setState({
        isTeamsDesktop: navigator.userAgent.match(/Teams/i)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectedDocument", function (fileUrl) {
      _this.setState({
        selectedDocument: fileUrl
      });

      _this.setState({
        selectedVideo: ''
      });

      _this.setState({
        selectedImage: ''
      });

      _this.setState({
        selectedAudio: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectedVideo", function (fileUrl) {
      _this.setState({
        selectedDocument: ''
      });

      _this.setState({
        selectedVideo: fileUrl
      });

      _this.setState({
        selectedImage: ''
      });

      _this.setState({
        selectedAudio: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectedImage", function (fileUrl) {
      _this.setState({
        selectedDocument: ''
      });

      _this.setState({
        selectedVideo: ''
      });

      _this.setState({
        selectedImage: fileUrl
      });

      _this.setState({
        selectedAudio: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectedAudio", function (fileUrl) {
      _this.setState({
        selectedDocument: ''
      });

      _this.setState({
        selectedVideo: ''
      });

      _this.setState({
        selectedImage: ''
      });

      _this.setState({
        selectedAudio: fileUrl
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeDocument", function (fileName) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then(function (result) {
        if (result.value != null) {
          _this.setState({
            assignmentAttachementLoading: true
          });

          _this.props.deleteAssignmentUserDocument(_this.props.assignmentId, fileName).then(function () {
            _this.loadUserAssignmentAttachedDocument(_this.props.taskId);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleSidebar", function () {
      _this.setState({
        sidebar: !_this.state.sidebar
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleConversation", function () {
      _this.setState({
        conversation: !_this.state.conversation
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStatusSelect", function (item, value) {
      if (!_this.isTaskAssessable()) {
        api.put("assignments/Student/Status?assignmentTaskId=" + item.id + "&status=" + value.value).then(function () {
          _this.props.addError(_this.props.translate('changes-saved'), 'info');

          item.status = value.value;

          _this.loadInit(_this.props.taskId);
        });
        return;
      }

      api.put("assignments/Student/Status?assignmentTaskId=" + item.id + "&status=" + value.value).then(function () {
        _this.props.addError(_this.props.translate('changes-saved'), 'info');

        item.status = value.value;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isTaskAssessable", function () {
      return _this.props.assignmentTask.status === 'ASSIGNMENT_TASK_SUBMITTED' || _this.props.assignmentTask.status === 'ASSIGNMENT_TASK_NOT_COMPLETE' || _this.props.assignmentTask.status === 'ASSIGNMENT_TASK_CAN_DEVELOP';
    });

    _defineProperty(_assertThisInitialized(_this), "assessmentSubmitting", function (submitting) {
      _this.setState({
        assessmentSubmitting: submitting
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAssessmentSubmit", function (values) {
      return new Promise(function (resolve) {
        var assignmentTask = _this.props.assignmentTask;

        if (values.id != null) {
          var existing = _this.props.assessments.find(function (assessment) {
            return assessment.id == values.id;
          });

          _this.props.updateAssessment(values, existing).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this.props.getAssignmentAssessment(_this.props.assignmentId);

                  case 2:
                    resolve(1);

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })));

          return true;
        }

        var data = _objectSpread(_objectSpread({}, values), {}, {
          assignmentId: _this.props.assignment.id,
          referenceId: assignmentTask.id,
          studentId: assignmentTask.assignedTo
        });

        _this.props.createAssessments([data]).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this.props.getAssignmentAssessment(_this.props.assignmentId);

                case 2:
                  resolve(1);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "goPrevious", function () {
      if (!_this.props.previousEnable) {
        return;
      }

      if (!_this.isTaskAssessable()) {
        _this.props.goPrevious();

        return;
      }

      if (_this.clickChildSubmit != null) {
        _this.clickChildSubmit().then(function () {
          _this.props.goPrevious();
        });
      } else {
        _this.props.goPrevious();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "goNext", function () {
      if (!_this.props.nextEnable) {
        return;
      }

      if (!_this.isTaskAssessable()) {
        _this.props.goNext();

        return;
      }

      if (_this.clickChildSubmit != null) {
        _this.clickChildSubmit().then(function () {
          _this.props.goNext();
        });
      } else {
        _this.props.goNext();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderAssess", function () {
      var conversation = null;

      if (_this.props.conversations != null) {
        conversation = _this.props.conversations.find(function (conv) {
          return conv.memberships.find(function (member) {
            return member.membershipID == _this.props.assignmentTask.students[0].userId;
          });
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.75rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          cursor: 'pointer'
        },
        onClick: _this.goPrevious
      }, _this.toggleIcon(false)), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          display: 'flex',
          textAlign: 'center',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 500,
          flex: '1'
        }
      }, _this.props.assignmentTask.groupName, _this.state.assessmentSubmitting ? /*#__PURE__*/React.createElement("span", {
        className: "assessment-publishing"
      }, /*#__PURE__*/React.createElement(Spinner, {
        small: true
      })) : /*#__PURE__*/React.createElement("span", {
        className: "conversation-trigger",
        onClick: _this.toggleConversation
      }, conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "badge"
      }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null, /*#__PURE__*/React.createElement(Icon, {
        name: "Message",
        bw: conversation == null
      })))), /*#__PURE__*/React.createElement("div", {
        style: {
          cursor: 'pointer'
        },
        onClick: _this.goNext
      }, _this.toggleIcon(true))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), _this.renderStatus());
    });

    _defineProperty(_assertThisInitialized(_this), "renderNoDocuments", function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("strong", null, _this.props.translate('no-files-found')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderUserAssignmentAttachedDocument", function () {
      var _this$state = _this.state,
          selectedDocument = _this$state.selectedDocument,
          selectedVideo = _this$state.selectedVideo,
          selectedImage = _this$state.selectedImage,
          selectedAudio = _this$state.selectedAudio;
      return _this.props.folderFiles.map(function (file) {
        var notOfficeFile = file.webUrlViewMode === '';
        var mp4File = notOfficeFile && /.mp4$/.test(file.webUrl);
        var imageFile = notOfficeFile && /(.png|.jpg|.gif|.jpeg)$/.test(file.webUrl);
        var m4aFile = notOfficeFile && /.m4a$/.test(file.webUrl);
        var dynamicClass = !notOfficeFile && selectedDocument === file.webUrlViewMode ? 'selected' : mp4File && selectedVideo === file.webUrl ? 'selected' : imageFile && selectedImage === file.webUrl ? 'selected' : m4aFile && selectedAudio === file.webUrl ? 'selected' : '';
        var classNameForDocument = 'document ' + dynamicClass;

        var onClickDocumentFunc = function onClickDocumentFunc() {
          var url = file.webUrlViewMode.replace('#', '?');
          var token = jwtDecode(decodeURI(_this.getParameterByName('access_token', url)));

          if (Moment.unix(token.exp).utc().isBefore(Moment())) {
            _this.setState({
              assignmentAttachementLoading: true,
              selectedDocument: '',
              selectedVideo: '',
              selectedImage: '',
              selectedAudio: ''
            });

            _this.props.assignment.tasks.forEach(function (t) {
              return t.selected = false;
            });

            _this.props.getFolderFiles(_this.props.assignmentId, _this.props.taskId).then(function () {
              _this.setState({
                assignmentAttachementLoading: false
              });

              var newFile = _this.props.folderFiles.find(function (newFile) {
                return newFile.eTag == file.eTag;
              });

              if (newFile != null) {
                if (!notOfficeFile) {
                  _this.selectedDocument(newFile.webUrlViewMode);
                } else if (mp4File) {
                  _this.selectedVideo(newFile.webUrl);
                } else if (imageFile) {
                  _this.selectedImage(newFile.webUrl);
                } else if (m4aFile) {
                  _this.selectedAudio(newFile.webUrl);
                }
              }
            });
          } else {
            if (!notOfficeFile) {
              _this.selectedDocument(file.webUrlViewMode);
            } else if (mp4File) {
              _this.selectedVideo(file.webUrl);
            } else if (imageFile) {
              _this.selectedImage(file.webUrl);
            } else if (m4aFile) {
              _this.selectedAudio(file.webUrl);
            }
          }
        };

        return /*#__PURE__*/React.createElement("div", {
          className: classNameForDocument,
          key: file.id,
          onClick: onClickDocumentFunc
        }, /*#__PURE__*/React.createElement("div", {
          className: "title"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "File"
        }), file.name), /*#__PURE__*/React.createElement("div", {
          className: "action"
        }, (!_this.props.IsSubmitted || _this.props.IsTeacher) && !notOfficeFile && file && (file.webUrlViewMode && file.webUrlViewMode.length < 2047 || file.webUrlEditMode && file.webUrlEditMode.length < 2047) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
          style: {
            display: "inline-block"
          },
          href: file.webUrlEditMode,
          target: "_blank"
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
          name: "Pen_Small"
        })), _this.props.translate('Edit') + ' ', "(", _this.props.translate('opens-in-new-tab'), ")")) : null, _this.props.IsTeacher ? null : !_this.props.IsSubmitted ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
          to: "#",
          style: {
            marginTop: '0.65rem',
            display: "inline-block"
          },
          onClick: function onClick() {
            _this.removeDocument(file.name);
          }
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
          name: "Bin"
        })), _this.props.translate('Remove'))) : null), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderWopiFrame", function () {
      var selectedDocument = _this.state.selectedDocument;

      if (_this.props.folderFiles.length <= 0) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement("strong", null, _this.props.translate('No files to view.')));
      }

      if (sniffer.isDevice && _this.inIframe()) {
        return /*#__PURE__*/React.createElement("div", {
          className: "df aic jcc y fc",
          style: {
            padding: '3rem'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "warning-box",
          style: {
            width: 'auto',
            marginBottom: '2rem'
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            alignSelf: 'flex-start'
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Info_Blue"
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex',
            flexDirection: 'column'
          }
        }, /*#__PURE__*/React.createElement("p", null, _this.props.translate("We’re sorry but we can’t display the file in Haldor at the moment. But you can open it by clicking “Open file in workspace”.")))), /*#__PURE__*/React.createElement("a", {
          href: selectedDocument,
          target: "_blank"
        }, /*#__PURE__*/React.createElement(Button, {
          type: "secondary"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "External"
        }), _this.props.translate("open-file-in-workspace"))));
      }

      return /*#__PURE__*/React.createElement("div", null, selectedDocument ? /*#__PURE__*/React.createElement(WopiFrame, {
        activeFile: selectedDocument
      }) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderMp4Frame", function () {
      var selectedVideo = _this.state.selectedVideo;

      if (_this.props.folderFiles.length <= 0) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement("strong", null, "No files to play."));
      }

      return /*#__PURE__*/React.createElement("div", null, selectedVideo ? /*#__PURE__*/React.createElement("video", {
        src: selectedVideo,
        controls: true,
        autoPlay: true,
        width: "100%",
        height: "600"
      }, _this.props.translate('Your browser does not support the video tag.')) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderM4aFrame", function () {
      var selectedAudio = _this.state.selectedAudio;

      if (_this.props.folderFiles.length <= 0) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement("strong", null, "No files to play."));
      }

      return /*#__PURE__*/React.createElement("div", null, selectedAudio ? /*#__PURE__*/React.createElement("audio", {
        controls: true,
        preload: "auto",
        autoPlay: true,
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("source", {
        src: selectedAudio,
        type: "audio/mp4"
      }), /*#__PURE__*/React.createElement("p", null, _this.props.translate('Your browser does not support the audio tag.'))) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderImageFrame", function () {
      var selectedImage = _this.state.selectedImage;

      if (_this.props.folderFiles.length <= 0) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement("strong", null, _this.props.translate('No images to view.')));
      }

      return /*#__PURE__*/React.createElement("div", null, selectedImage ? /*#__PURE__*/React.createElement("div", {
        style: {
          height: '600px',
          width: '100%',
          overflowX: 'scroll'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: selectedImage,
        width: "100%"
      })) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderView", function () {
      var _this$state2 = _this.state,
          selectedDocument = _this$state2.selectedDocument,
          selectedVideo = _this$state2.selectedVideo,
          selectedImage = _this$state2.selectedImage,
          selectedAudio = _this$state2.selectedAudio;

      if (selectedDocument) {
        return _this.renderWopiFrame();
      }

      if (selectedVideo) {
        return _this.renderMp4Frame();
      }

      if (selectedImage) {
        return _this.renderImageFrame();
      }

      if (selectedAudio) {
        return _this.renderM4aFrame();
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderStatus", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "status-change"
      }, /*#__PURE__*/React.createElement("label", null, _this.props.translate('Status')), /*#__PURE__*/React.createElement(SimpleSelect, {
        selectedValue: _this.props.assignmentTask.status,
        name: "assignment-status",
        disabled: _this.props.assignment.created == '0001-01-01T00:00:00' || _this.props.assignment.locked,
        item: _this.props.assignmentTask,
        type: "assignment",
        onChange: _this.onStatusSelect
      }));
    });

    _this.state = {
      selectedDocument: undefined,
      selectedVideo: undefined,
      selectedAudio: undefined,
      selectedImage: undefined,
      assignmentAttachementLoading: false,
      assignmentLoading: false,
      activeTask: [],
      isTeamsDesktop: false,
      activeTaskLoading: false,
      assessmentSubmitting: false,
      sidebar: true,
      sidebarWide: false,
      conversation: false
    };
    _this.clickChildSubmit = null;
    return _this;
  }

  _createClass(AttachedUserDocuments, [{
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "toggleIcon",
    value: function toggleIcon(flip) {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: flip ? 'i-90' : 'a-90',
        style: {
          height: '7px',
          width: '15px'
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    }
  }, {
    key: "getParameterByName",
    value: function getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state3 = this.state,
          assignmentAttachementLoading = _this$state3.assignmentAttachementLoading,
          activeTaskLoading = _this$state3.activeTaskLoading,
          sidebarWide = _this$state3.sidebarWide;
      var IsTeacher = this.props.IsTeacher;
      var activeConversation = null;

      if (this.state.conversation) {
        activeConversation = this.props.assignmentTask.students[0];
      }

      var assessmentBlocks = null;
      var assessment = null;
      var seperatedAssessments = {
        peerAssessments: [],
        teacherAssessments: [],
        selfAssessments: []
      };

      if (this.props.blocks != null) {
        var _assessmentBlocks$fil;

        assessmentBlocks = _toConsumableArray(this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });
        seperatedAssessments.peerAssessments = (_assessmentBlocks$fil = assessmentBlocks.filter(function (block) {
          return block.assessmentType == ASSESSMENT_TYPES.PEER && block.resources.length > 0;
        })) === null || _assessmentBlocks$fil === void 0 ? void 0 : _assessmentBlocks$fil.sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
        seperatedAssessments.teacherAssessments = assessmentBlocks.filter(function (block) {
          return (block.assessmentType == ASSESSMENT_TYPES.TEACHER || block.assessmentType == null) && block.resources.length > 0;
        }).sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
        seperatedAssessments.selfAssessments = assessmentBlocks.filter(function (block) {
          return block.assessmentType == ASSESSMENT_TYPES.SELF && block.resources.length > 0;
        }).sort(function (a, b) {
          return a.title.localeCompare(b.title);
        });
      }

      if (this.props.assessments != null) {
        assessment = this.props.assessments.find(function (assessment) {
          return assessment.referenceId == _this2.props.assignmentTask.id && assessment.assessorType == ASSESSMENT_TYPES.TEACHER;
        });
      }

      if (this.state.assignmentLoading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: sidebarWide ? "attached-user-documents wide" : "attached-user-documents"
      }, /*#__PURE__*/React.createElement(Message, {
        assignment: this.props.assignment,
        activeUser: activeConversation,
        onClose: this.toggleConversation
      }), /*#__PURE__*/React.createElement("div", {
        className: "iframe-section left-side"
      }, assignmentAttachementLoading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.renderView()), this.state.sidebar ? /*#__PURE__*/React.createElement("div", {
        className: "sidebar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "collapse color--meta",
        onClick: this.toggleSidebar
      }, this.props.translate('fold-up'), " ", /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowRight"
      })), IsTeacher ? this.renderAssess() : null, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('details'),
        route: "details"
      }, assignmentAttachementLoading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : this.props.folderFiles.length <= 0 ? this.renderNoDocuments() : this.renderUserAssignmentAttachedDocument()), IsTeacher ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Assessment'),
        route: "assessment"
      }, !activeTaskLoading ? this.isTaskAssessable() ? /*#__PURE__*/React.createElement(AssessmentForm, {
        onSubmit: this.onAssessmentSubmit,
        items: [this.props.assignmentTask],
        blocks: seperatedAssessments.teacherAssessments,
        initialValues: assessment,
        referenceType: "AssignmentTask",
        showStudents: false
      }) : /*#__PURE__*/React.createElement("div", {
        style: {
          padding: "1rem"
        },
        className: "color--meta text--center"
      }, this.props.translate("Student-has-not-submitted-assignment")) : null) : null)) : /*#__PURE__*/React.createElement("div", {
        className: "expand color--meta",
        onClick: this.toggleSidebar
      }, this.props.translate('fold-out'), " ", /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowLeft"
      })));
    }
  }]);

  return AttachedUserDocuments;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    folderFiles: state.assignments.folderFiles,
    assignment: state.assignments.active_assignment,
    currentUser: state.user.currentUser,
    sections: state.sections.educationGroups,
    assessments: state.assessments.assessments,
    conversations: state.Conversation.referenceConversations,
    blocks: state.Blocks.reference
  };
}

export default connect(mapStateToProps, {
  getFolderFiles: getFolderFiles,
  deleteAssignmentUserDocument: deleteAssignmentUserDocument,
  getTaskDetails: getTaskDetails,
  getSection: getSection,
  getStudentAssessments: getStudentAssessments,
  getStudentAssessment: getStudentAssessment,
  getAssignmentAssessment: getAssignmentAssessment,
  addError: addError,
  createAssessments: createAssessments,
  updateAssessment: updateAssessment,
  getBlocksByReference: getBlocksByReference
})(AttachedUserDocuments);